/**
 * Elite plan preview page – Navbar + ArtistEliteProfile + Footer.
 */

import React from "react";
import { Navbar } from "@/templates/Navbar";
import { Footer } from "@/templates/Footer";
import ArtistEliteProfile from "./Elite/ArtistEliteProfile";

export interface ElitePreviewProps {
  isMobile?: boolean;
}

export default function ElitePreview({ isMobile = false }: ElitePreviewProps) {
  return (
    <div className="text-white">
      {/* <Navbar /> */}
      <ArtistEliteProfile isMobile={isMobile} />
      <Footer />
    </div>
  );
}
